"use client";
import { Button } from "@/components/ui/button";
import { Sheet, SheetClose, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { useGetLoggedInUser } from "@/hooks/use-get-logged-in-user";
import { cn } from "@/lib/utils";
import { Menu } from "lucide-react";
import type { Route } from "next";
import Link from "next/link";
import { usePathname } from "next/navigation";
import * as React from "react";
import { useSidebar } from "../../../stores/sidebar.atoms";

export function BurgerMenuMobile() {
    const [isBurgerMenuOpen, setIsBurgerMenuOpen] = React.useState(false);
    const { user: userProfile } = useGetLoggedInUser();
    const [, setSidebar] = useSidebar();

    return (
        <>
            <Sheet open={isBurgerMenuOpen} onOpenChange={setIsBurgerMenuOpen}>
                <SheetTrigger asChild>
                    <Button size="icon" variant="ghost" className="mr-3">
                        <Menu />
                    </Button>
                </SheetTrigger>

                <SheetContent side="left" className="max-w-[220px]">
                    <div className="flex h-full flex-col">
                        <nav className="flex h-full flex-col items-start justify-center gap-3">
                            <NavItem href="/home">Home</NavItem>
                            <hr className="w-full" />
                            <NavItem href="/onboard">Onboard</NavItem>
                            <hr className="w-full" />
                            <NavItem href="/plans">Plans</NavItem>
                            <hr className="w-full" />
                            <NavItem href="/blog">Blog</NavItem>
                        </nav>
                        {userProfile === null && (
                            <>
                                <Button
                                    variant="outline"
                                    onClick={(e) => {
                                        e.preventDefault();

                                        setIsBurgerMenuOpen(false);

                                        setTimeout(() => {
                                            setSidebar({ open: true, type: "login" });
                                        }, 500);
                                    }}
                                    className="mb-4"
                                >
                                    Log In
                                </Button>

                                <Button
                                    onClick={(e) => {
                                        e.preventDefault();

                                        setIsBurgerMenuOpen(false);

                                        setTimeout(() => {
                                            setSidebar({ open: true, type: "signup" });
                                        }, 500);
                                    }}
                                    className="mb-4"
                                >
                                    Sign Up
                                </Button>
                            </>
                        )}

                        {userProfile && (
                            <Button asChild>
                                <Link href="/dashboard">Go to Dashboard</Link>
                            </Button>
                        )}
                    </div>
                </SheetContent>
            </Sheet>
        </>
    );
}

function NavItem({ href, children }: { href: Route; children: React.ReactNode }) {
    const pathname = usePathname();
    const isActive = pathname === href;

    return (
        <SheetClose asChild>
            <Link
                className={cn(
                    "font-medium text-base text-muted-foreground transition-all hover:text-foreground active:text-white",
                    {
                        "font-semibold text-foreground": isActive,
                    },
                )}
                href={href}
            >
                {children}
            </Link>
        </SheetClose>
    );
}
